import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';

// bayclubs module
import { UtilsModule } from '@bayclubs/utils';
import { DropDownModule } from '@bayclubs/drop-down';

//application modules
import { InfrastructureModule } from '../infrastructure/infrastructure.module';

//application components
import { InstructorSearchComponent } from './components/instructor-search/instructor-search.component';
import { RouterModule } from '@angular/router';
import { ProviderAvatarPhotoComponent } from './components/provider-avatar-photo/provider-avatar-photo.component';
import { ManagementHttpClient } from './services/management-http-client';
import { SubBoardHttpClient } from './services/sub-board-http-client';
import { SubBoardApiService } from './services/sub-board-api.service';
import { ManagementContextResolverService } from './services/management-context-resolver.service';
import { ContextApiService } from './services/context.api.service';
import { GroupClassesApiService } from './services/group-classes-api.service';
import { ProvidersHttpClient } from './services/providers-http-client';
import { ProvidersApiService } from './services/providers.api.service';
import { PrivilegesSnapshotResolverService } from './services/privileges-snapshot-resolver.service';
import { InstructorsApiService } from './services/instructors.api.service';
import { DataFilteringService } from './services/data-filtering.service';
import { MemberSearchComponent } from './components/member-search/member-search.component';
import { VisibleInConnectPipe } from './pipes/visible-in-connect.pipe';
import { FiltersStorageService } from './services/filters-storage.service';
import { LocationSortingService } from './services/location-sorting.service';

@NgModule({
    declarations: [
        ProviderAvatarPhotoComponent,
        InstructorSearchComponent,
        MemberSearchComponent,
        VisibleInConnectPipe
    ],
    imports: [
        CommonModule,
        UtilsModule,
        InfrastructureModule,
        RouterModule,
        FormsModule,
        ReactiveFormsModule,
        TranslateModule.forChild(),
        DropDownModule,
    ],
    providers: [
        FiltersStorageService,
        ManagementHttpClient,
        GroupClassesApiService,
        SubBoardHttpClient,
        SubBoardApiService,
        ContextApiService,
        ManagementContextResolverService,
        ProvidersHttpClient,
        ProvidersApiService,
        PrivilegesSnapshotResolverService,
        InstructorsApiService,
        DataFilteringService,
        LocationSortingService
    ],
    exports: [
        ProviderAvatarPhotoComponent,
        InstructorSearchComponent,
        MemberSearchComponent,
        VisibleInConnectPipe
    ]
})
export class SharedModule { }

// services
export { FiltersStorageService } from './services/filters-storage.service';
export { ManagementHttpClient } from './services/management-http-client';
export { GroupClassesApiService } from './services/group-classes-api.service';
export { DataFilteringService } from './services/data-filtering.service';

export { SubBoardHttpClient } from './services/sub-board-http-client';
export { SubBoardApiService } from './services/sub-board-api.service';

export { ProvidersApiService } from './services/providers.api.service';
export { ProvidersHttpClient } from './services/providers-http-client';

export { ManagementContextResolverService } from './services/management-context-resolver.service';
export { PrivilegesSnapshotResolverService } from './services/privileges-snapshot-resolver.service';

export { InstructorSearchComponent } from './components/instructor-search/instructor-search.component';
